import {
  PEER_INTERPOLATION_BACKTIME_MS,
  PEER_POSE_BUFFER_MAX,
} from "@cold-case/shared/player-pose";

export type PoseSample = {
  x: number;
  y: number;
  facing: string;
  seq: number;
  /** Local scene clock when sample arrived (interpolation clock). */
  receivedAtMs: number;
  /** Server relay time when present (informational). */
  serverSentAtMs?: number;
};

export function pushPoseSample(
  buffer: PoseSample[],
  sample: PoseSample
): PoseSample[] {
  const next = [...buffer, sample];
  if (next.length > PEER_POSE_BUFFER_MAX) {
    next.splice(0, next.length - PEER_POSE_BUFFER_MAX);
  }
  return next;
}

/** Target world position at render time (backtime interpolation between buffered samples). */
export function interpolatePeerTarget(
  samples: PoseSample[],
  last: PoseSample | undefined,
  renderAtMs: number
): { x: number; y: number } {
  if (!last) return { x: 0, y: 0 };
  let tx = last.x;
  let ty = last.y;
  if (samples.length >= 2) {
    let a = samples[0]!;
    let b = samples[samples.length - 1]!;
    for (let i = 1; i < samples.length; i++) {
      const s = samples[i]!;
      if (s.receivedAtMs >= renderAtMs) {
        b = s;
        a = samples[i - 1] ?? s;
        break;
      }
      a = s;
    }
    const span = Math.max(1, b.receivedAtMs - a.receivedAtMs);
    const t = Math.min(1, Math.max(0, (renderAtMs - a.receivedAtMs) / span));
    tx = a.x + (b.x - a.x) * t;
    ty = a.y + (b.y - a.y) * t;
  }
  return { x: tx, y: ty };
}

export function peerRenderAtMs(nowMs: number): number {
  return nowMs - PEER_INTERPOLATION_BACKTIME_MS;
}
